import { ROLES_REQUEST, ROLES_SHOW, ROLES_LIST, ROLE_EDIT, ROLE_PERMISSIONS, ROLES_DELETE, ROLES_COMPLETE, ROLES_CLEAR, ROLE_FAIL } from "../store/config";

const roleInit = {
	isFetching: false,
	list: [],
	pages:{
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	edit: {
		permissions: []
	},
	permissions: [],
	error: undefined
};

const roles = (state=roleInit,action) => {
	switch (action.type){
		case ROLES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case ROLES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case ROLES_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case ROLE_EDIT:
			return {
				...state,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case ROLE_PERMISSIONS:
			return {
				...state,
				edit:{
					...state.edit,
					permissions: action.payload
				},
				timestamp: action.timestamp
			}
		case ROLES_DELETE:
			return{
				...state,
				isFetching: action.isFetching,
				data:action.payload,
				timestamp:action.timestamp
			}
		case ROLES_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp

			}
		case ROLES_CLEAR:
			return {
				...state,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case ROLE_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
};

export default roles;


// WEBPACK FOOTER //
// ./src/reducers/roles.js